<div class="main-container">
  <div class="main-form" (click)="$event.stopPropagation()">
    <div class="dock-details">
      <span>Doca</span>
      <span>{{dockNumber}}</span>
    </div>

    <div class="dropdown">
      <label>Classificação</label>
      <div class="select" (click)="toggleDropdown()">
        <span class="selected">{{ selectedOption }}</span>
        <div class="caret" [class.caret-rotate]="dropdownOpen"></div>
      </div>
      <ul class="menu" [class.menu-open]="dropdownOpen">
        <li *ngFor="let option of options" (click)="selectOption(option)" [class.active]="option === selectedOption">
          {{ option }}
        </li>
      </ul>
    </div>

    <div class="planned-container">
      <span>Viagens planejadas</span>
      <button (click)="togglePlanning()" [ngClass]="{
        'btn-disabled': isMilkRun,
        'btn-enabled': isPlanned,
      }">
        <ng-container *ngIf="isPlanned; else disabledText">
          Planejado
        </ng-container>
        <ng-template #disabledText>
          desabilitado
        </ng-template>
      </button>
    </div>

    <div class="search-input">
      <span>BUSCAR VIAGEM</span>
      <input type="text"
        [placeholder]="selectedOption === 'milk-run'? 'desabilitado': 'Digite o código da viagem'"
        class="planning-input" [(ngModel)]="tripCode" (ngModelChange)="filterTripByCode()" [disabled]="isMilkRun"
        [ngClass]="{
          'input-enabled': isPlanned,
          'input-disabled': isMilkRun,
        }" />
    </div>

    <div class="planned-info" *ngIf="isPlanned">
      <ng-container *ngIf="plannedTripData; else emptyPlan">
        <table>
          <thead>
            <tr>
              <th>Viagem</th>
              <th>Classificação</th>
              <th>Empresa</th>
              <th>Tipo</th>
              <th>Entrada</th>
              <th>Saída</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{plannedTripData.trip}}</td>
              <td>{{plannedTripData.classification}}</td>
              <td>{{plannedTripData.company}}</td>
              <td>{{plannedTripData.category}}</td>
              <td>{{plannedTripData.arrivalTime}}</td>
              <td>{{plannedTripData.departureTime}}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-template #emptyPlan>
        <h2 class="empty-data">Nenhuma viagem encontrada</h2>
      </ng-template>
    </div>

    <div class="overflow-tables">
      <span>Tabelas auxiliares</span>
      <button (click)="toggleFisco()" [ngClass]="{
        'btn-disabled': isMilkRun,
        'btn-enabled': isPlanned,
      }">FISCO</button>
      <button (click)="toggleEtransport()" [ngClass]="{
        'btn-disabled': isPlanned,
        'btn-enabled': isMilkRun,
      }">Milkrun</button>
    </div>

    <div class="fisco-info" *ngIf="isPlanned">
      <ng-container *ngIf="sharedFiscoData; else emptyF">
        <p>FISCO - Registro selecionado</p>
        <table>
          <thead>
            <th>Registro</th>
            <th>Fornecedor</th>
            <th>Placa</th>
            <th>Tipo</th>
            <th>Chegada</th>
          </thead>
          <tbody>
            <td>{{sharedFiscoData.sequencia}}</td>
            <td>{{sharedFiscoData.fornecedor}}</td>
            <td>{{sharedFiscoData.placaVeiculo}}</td>
            <td>{{sharedFiscoData.tipoEntrada}}</td>
            <td>{{sharedFiscoData.entrada | date:'dd/MM/yyyy HH:mm'}}</td>
          </tbody>
        </table>
      </ng-container>
      <ng-template #emptyF>
        <h2 class="empty-data">FISCO - Nenhum registro selecionado</h2>
      </ng-template>
    </div>

    <div class="milkrun-info" *ngIf="isMilkRun">
      <ng-container *ngIf="sharedMilkrunData; else emptyMK">
        <p>MILK RUN - Registro selecionado</p>
        <table>
          <thead>
            <th>Registro</th>
            <th>Transportadora</th>
            <th>Placa</th>
            <th>Janela</th>
            <th>Área</th>
          </thead>
          <tbody>
            <td>{{sharedMilkrunData.Sequencia}}</td>
            <td>{{sharedMilkrunData.Transportadora}}</td>
            <td>{{sharedMilkrunData.Plate}}</td>
            <td>{{sharedMilkrunData.Janela | date:'dd/MM/yyyy HH:mm'}}</td>
            <td>{{sharedMilkrunData.Area}}</td>
          </tbody>
        </table>
      </ng-container>
      <ng-template #emptyMK>
        <h2 class="empty-data">MILKRUN - Nenhum registro selecionado</h2>
      </ng-template>
    </div>
    <button class="btn-save" (click)="shareTripData()">Salvar</button>
  </div>
</div>

<app-fisco-table *ngIf="fiscoIsVisible" (selectRow)="handleSelectFisco($event)"></app-fisco-table>
<app-milkrun-table *ngIf="eTransportIsVisible" (selectRow)="handleSelectMilkrun($event)"></app-milkrun-table>
<app-planning-table *ngIf="planningIsVisible"></app-planning-table>